
export const COLORS = {
  // Primary brand colors
  primary: "#710014",
  secondary: "#b39402",

  golden2: "#9c8105",

  coral: "#e58682",
  coralDark: "#c26662",

  // Indian-inspired gradient colors
  saffron: "#FF6B35",
  saffronLight: "#FF8A65",
  cream: "#FFF8E1",
  creamLight: "#FFFBEA",
  pistachio: "#A5D6A7",
  pistachioLight: "#C8E6C9",
  pastelPink: "#F8BBD9",
  lightYellow: "#FFF9C4",
  
  // Legacy colors
  golden: '#beb163',
  danger: '#ed1c24',
  darkGrey1: "#333333",
  darkGrey2: "#444444",
  lightGrey: "#cbcbcb",
  lightGrey1: "#777777",
  lightGrey2: "#696969",
  white: "#ffffff",
  black: "#000000",
  success: "#00b300",
  
  // New premium colors
  textPrimary: "#2C2C2C",
  textSecondary: "#666666",
  backgroundLight: "#FAFAFA",
  borderLight: "#E0E0E0",
};